import { getIcon } from '@cheqroom/icons';
import { FC } from 'react';

import { Info } from '../../Info';
import { useItemInfoContext } from '../ItemInfo.context';

export const ItemType: FC = () => {
	const { item, workspace } = useItemInfoContext();

	const itemType = workspace?.itemTypes?.find((itemType) => itemType.id === item.itemTypeId);
	if (!itemType) return null;

	const IconComponent = getIcon(itemType.icon, 'Database');

	return <Info icon={IconComponent} text={itemType.name} />;
};
